
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/data-grid/grid-api",
      function () {
        return require("private-next-pages/x/api/data-grid/grid-api.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/data-grid/grid-api"])
      });
    }
  